import React from 'react';
import { EcoClub6Class2026 } from '../views';


const AccountGeneralPage = () => {
  return <EcoClub6Class2026/>;
};

export default AccountGeneralPage;